import React from 'react'
import { Link } from '@raysync/common/components'
import { TagContainer } from './tag-box.atom'

class TagBox extends React.PureComponent {
  render() {
    const { data, isBlog } = this.props
    return (
      <TagContainer>
        {data.map((tag, index) => {
          return (
            <React.Fragment key={tag.slug + index}>
              <Link style={{ fontSize: 14 }} to={`/${isBlog ? 'blog' : 'news'}/${tag.slug}/`}>
                {tag.name}
              </Link>
              {index + 1 !== data.length && <span>|</span>}
            </React.Fragment>
          )
        })}
      </TagContainer>
    )
  }
}
export default TagBox
